<template>
  <main id="subPage">
    <!-- 카테고리 -->
    <section id="category">
      <h2>공영주차장</h2>
      <ul class="breadCrumb">
        <li class="home"></li>
        <li class="web">
          <p class="pageTxt">공영주차장</p>
          <ul class="depth">
            <li><router-link to="/map" title="공영주차장">공영주차장</router-link></li>
            <li><router-link to="/unpaidinfo" title="주차요금정산">주차요금정산</router-link></li>
            <li><router-link to="/periodinfo" title="주차서비스">주차서비스</router-link></li>
            <li><router-link to="/noticelist" title="정보마당">정보마당</router-link></li>
          </ul>
        </li>
        <li class="web">
          <p class="pageTxt">노외주차장 검색</p>
          <ul class="depth">
            <li><router-link to="/map" title="노외주차장 검색">노외주차장 검색</router-link></li>
            <li><router-link to="/parkfeeinformation" title="주차장 이용안내">주차장 이용안내</router-link></li>
            <li><router-link to="/parkfeereduction" title="주차요금 감면안내">주차요금 감면안내</router-link></li>
          </ul>
        </li>
        <li>
          <p class="pageTxt">주소 검색</p>
          <ul class="depth">
            <li><router-link to="/map" title="지도 검색">지도 검색</router-link></li>
            <li><router-link to="/list" title="주소 검색">주소 검색</router-link></li>
          </ul>
        </li>
      </ul>
    </section>

    <!-- 컨텐츠 영역 -->
    <section id="content">
      <div class="inner">
        <div id="tabs">
          <ul class="tabMenu">
            <li><router-link to="/map" title="지도 검색">지도 검색</router-link></li>
            <li class="active"><router-link to="/list" title="주소 검색">주소 검색</router-link></li>
          </ul>
          <section class="tabCont">
            <article class="selectOpt">
              <dl>
                <dt>주차장 종류</dt>
                <dd>
                  <select name="" id="" title="주차장종류 선택" v-model="parkingKind">
                    <option :value="'0'">전체</option>
                    <option :value="'공영'">공영</option>
                    <option :value="'공원'">공원</option>
                    <option :value="'부설'">부설</option>
                  </select>
                </dd>
              </dl>
              <dl>
                <dt>검색어</dt>
                <dd>
                  <select name="" id="" title="검색조건 선택" v-model="searchOption">
                    <option :value="'0'">전체</option>
                    <option :value="'1'">주차장명</option>
                    <option :value="'2'">주소</option>
                  </select>
                  <input
                    type="text"
                    title="주소 입력"
                    placeholder="주차장명 또는 주소입력"
                    v-model="parkingName"
                    @keyup.enter="getParkingInfo"
                  />
                  <button type="button" class="btn dkGray" @click="getParkingInfo">검색</button>
                </dd>
              </dl>
            </article>
            <article>
              <div class="scroll-table">
                <i class="v-scroll"></i>
                <div class="table vertical-table">
                  <table>
                    <caption>
                      주소검색 테이블
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">구분</th>
                        <th scope="col">주차장명</th>
                        <th scope="col">주소</th>
                        <th scope="col">주차면수</th>
                        <th scope="col">장애인면수</th>
                        <th scope="col">기본요금(30분)</th>
                        <th scope="col">간격요금(10분)</th>
                        <th scope="col">상세내역보기</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in parkingList" :key="index">
                        <td>{{ item.PARKING_DIV_NM }}</td>
                        <td>{{ item.PARKING_NM }}</td>
                        <td>{{ item.CELL_ADDR_JIBUN }}</td>
                        <td>{{ item.CELL_CNT }}</td>
                        <td>{{ item.HNDCAP_CELL_CNT }}</td>
                        <td v-if="item.PARKING_NM == '남천상가'">기본요금(1시간)<br />600원</td>
                        <td v-else>{{ item.DFLT_AMT | comma }}원</td>
                        <td v-if="item.PARKING_NM == '남천상가'">250원</td>
                        <td v-else>{{ item.INTVL_AMT | comma }}원</td>
                        <td>
                          <button type="button" class="more" @click="detailInfo(item)">
                            <span class="hidden">자세히 보기</span>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </article>

            <parking-popup v-if="popShow" class="parking">
              <template #info> 주차장 정보 </template>
              <template #content>
                <article class="paragraph">
                  <p>{{ parkingModalInfo.PARKING_NM }}</p>
                </article>
                <article>
                  <div class="flex">
                    <div class="table park-table">
                      <table>
                        <caption>
                          주차장 상세정보
                        </caption>
                        <colgroup>
                          <col style="width: 25%" />
                          <col style="width: 25%" />
                          <col style="width: 25%" />
                          <col style="width: 25%" />
                        </colgroup>
                        <tbody>
                          <tr>
                            <th scope="row">주차면수</th>
                            <td>{{ parkingModalInfo.CELL_CNT }}</td>
                            <th scope="row">주차 가용대수</th>
                            <td>{{ parkingModalInfo.PARK_COUNT }}</td>
                          </tr>
                          <tr>
                            <th scope="row">장애인주차</th>
                            <td>{{ parkingModalInfo.HNDCAP_CELL_CNT }}</td>
                            <th scope="row">전기차 주차</th>
                            <td>{{ parkingModalInfo.ELEC_CELL_CNT }}</td>
                          </tr>
                          <tr>
                            <th scope="row">주소</th>
                            <td colspan="3" class="txt-left">{{ parkingModalInfo.CELL_ADDR_JIBUN }}</td>
                          </tr>
                          <tr>
                            <th scope="row">일반요금</th>
                            <td colspan="3">
                              <div class="table sky-table">
                                <table>
                                  <caption>
                                    일반요금 상세정보
                                  </caption>
                                  <template v-if="parkingModalInfo.PARKING_ID == 4">
                                    <thead>
                                      <tr>
                                        <th scope="col">최초60분</th>
                                        <th scope="col">10분당</th>
                                        <th scope="col">일일요금</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>600원</td>
                                        <td>250원</td>
                                        <td>{{ parkingModalInfo.DAY_PARKING_AMT | comma }}원</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                  <template v-else>
                                    <thead>
                                      <tr>
                                        <th scope="col">최초{{ parkingModalInfo.DFLT_TM }}분</th>
                                        <th scope="col">{{ parkingModalInfo.INTVL_TM }}분당</th>
                                        <th scope="col">일일요금</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr>
                                        <td>{{ parkingModalInfo.DFLT_AMT | comma }}원</td>
                                        <td>{{ parkingModalInfo.INTVL_AMT | comma }}원</td>
                                        <td>{{ parkingModalInfo.DAY_PARKING_AMT | comma }}원</td>
                                      </tr>
                                    </tbody>
                                  </template>
                                </table>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">이용시간</th>
                            <td colspan="3">
                              <div class="table sky-table">
                                <table>
                                  <caption>이용시간 상세정보</caption>
                                  <thead>
                                  <tr>
                                    <template v-if="parkingModalInfo.ANYHOUR_RUN_YN === '24시간운영함'">
                                      <th scope="col">평일, 주말 및 공휴일</th>
                                    </template>
                                    <template v-else>
                                      <th scope="col">주간</th>
                                      <th scope="col">야간</th>
                                    </template>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <template v-if="parkingModalInfo.ANYHOUR_RUN_YN === '24시간운영함'">
                                      <td>24시간 유료 운영</td>
                                    </template>
                                    <template v-else>
                                      <td>08:00~20:00</td>
                                      <td>20:00~08:00</td>
                                    </template>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                          <tr>
                            <th scope="row">휴무일</th>
                            <td colspan="3" class="txt-left"></td>
                          </tr>
                          <tr>
                            <th scope="row">월 정기권</th>
                            <td colspan="3">
                              <div class="table sky-table">
                                <table>
                                  <caption>월 정기권 상세정보</caption>
                                  <thead>
                                  <tr>
                                    <th scope="col">주간 (8:00~20:00)</th>
                                    <th scope="col">야간 <br>(18:30~다음날 8:00)</th>
                                    <th scope="col">주야간 <br>(8:00~다음날 8:00)</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr>
                                    <!-- 1) 주간 금액 -->
                                    <td>
                                      <span v-if="parkingModalInfo.PERIOD_DAYTM_AMT == 0">미운영</span>
                                      <span v-else>{{ parkingModalInfo.PERIOD_DAYTM_AMT | comma }}원</span>
                                    </td>

                                    <!-- 2) 야간 금액 -->
                                    <td>
                                      <span v-if="parkingModalInfo.PERIOD_NIGHT_AMT == 0">미운영</span>
                                      <span v-else>{{ parkingModalInfo.PERIOD_NIGHT_AMT | comma }}원</span>
                                    </td>

                                    <!-- 3) 주야간 -->
                                    <td>
                                      <span v-if="parkingModalInfo.PERIOD_TICKET_AMT == 0">미운영</span>
                                      <span v-else>
                                        {{ parkingModalInfo.PERIOD_TICKET_AMT | comma }}원
                                      </span>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="kakaoMap">
                      <button type="button" class="btn findRoad" @click="findRoads(parkingModalInfo)">길찾기</button>
                      <!-- Map 화면 들어갈 곳 -->
                      <div id="mapWrapper">
                        <KakaoMap
                          :centerPositions="[parkingModalInfo.LAT, parkingModalInfo.LNG]"
                          :parkingList="parkingLocation"
                          @kakaoMapMarker="kakaoMapMarker"
                        />
                      </div>
                    </div>
                  </div>
                </article>
                <article class="btnArea">
                  <button class="btn blue" @click="CancleBtn">확인</button>
                </article>
              </template>
              <template #button>
                <button class="btn closeBtn" @click="CancleBtn"><span class="hidden">닫기</span></button>
              </template>
            </parking-popup>
          </section>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import axios from '../../../util/axios';
import parkingPopup from '../../../components/PopupType1.vue';
import KakaoMap from '../../../components/KakaoMap.vue';

export default {
  data() {
    return {
      popShow: false,
      parkingKind: '0',
      searchOption: '0',
      parkingName: '',
      nodata: true,
      parkingList: [],
      parkingModalInfo: {},
      markers: [],
      map: null,
      positions: [],
      parkingLocation: [],
      customOverlay: [],
      ckImg: null,
      imageSize: null,
      rv: null,
      rvClient: null,
      container: null,
      kakaoVali: -1,
    };
  },

  components: {
    parkingPopup,
    KakaoMap,
  },

  mounted() {
    if (this.$route.query.q !== null) {
      this.parkingName = this.$route.query.q;
    } else {
      this.parkingName = '';
    }

    this.getParkingInfo();
  },

  methods: {
    kakaoMapMarker(marker, map, positions) {
      this.markers = marker;
      this.map = map;
      this.positions = positions;
      for (let i = 0; i < this.markers.length; i++) {
        if (this.parkingLocation[0].PARK_COUNT === null || this.parkingLocation[0].PARK_COUNT === 0) {
          this.parkingLocation[0].PARK_COUNT = 0;
        }
        const customContent =
          '<div class="mapCustomOverlay-box" style="min-height:0; width:200px;">' +
          '<dl style="margin-bottom: 0px;"><dt>[' +
          this.parkingLocation[i].PARKING_DIV_NM +
          '] ' +
          this.parkingLocation[i].PARKING_NM +
          '</dt></dl>' +
          '</div>';
        this.customOverlay[0] = new kakao.maps.CustomOverlay({
          position: this.positions[0],
          content: customContent,
          yAnchor: 0.1,
        });

        kakao.maps.event.addListener(this.markers[0], 'mouseover', () => {
          // 마커 호버 이벤트
          this.customOverlay[0].setMap(this.map);
        });
        kakao.maps.event.addListener(this.markers[0], 'mouseout', () => {
          // 마커 호버아웃 이벤트
          this.customOverlay[0].setMap(null);
        });
      }

      // 마커 이미지를 생성합니다
      let rvMarkImage = new kakao.maps.MarkerImage(
        'https://t1.daumcdn.net/localimg/localimages/07/2018/pc/roadview_minimap_wk_2018.png',
        new kakao.maps.Size(37, 44),
        {
          // 스프라이트 이미지를 사용합니다.
          // 스프라이트 이미지 전체의 크기를 지정하고
          spriteSize: new kakao.maps.Size(1666, 168),
          // 사용하고 싶은 영역의 좌상단 좌표를 입력합니다.
          // background-position으로 지정하는 값이며 부호는 반대입니다.
          spriteOrigin: new kakao.maps.Point(705, 114),
          offset: new kakao.maps.Point(13, 46),
        },
      );
      const mapCenter = new kakao.maps.LatLng(this.parkingLocation[0].LAT, this.parkingLocation[0].LNG);
      this.marker = new kakao.maps.Marker({
        image: rvMarkImage,
        position: mapCenter,
        draggable: true,
      });
      this.positions.splice(0, 1);
      this.markers.splice(0, 1);
    },

    detailInfo(item) {
      this.popShow = true;
      this.parkingModalInfo = item;
      this.parkingLocation = [item];
    },

    CancleBtn() {
      this.popShow = false;
    },

    async getParkingInfo() {
      const res = await axios('get', '/api/parking/searchParkingList.json');
      const data = res.data;
      if (!data.parkingList || !(data.parkingList.length > 0)) {
        this.parkingList = [];
        this.nodata = true;
        return;
      }
      this.parkingList = data.parkingList;
      if (this.parkingKind !== '0') {
        if (this.searchOption === '0') {
          //전체
          if (this.parkingName === undefined) {
            this.parkingList = this.parkingList.filter(v => v.PARKING_DIV_NM?.includes(this.parkingKind));
          } else if (this.parkingName !== undefined) {
            this.parkingList = this.parkingList.filter(
              v =>
                v.PARKING_DIV_NM?.includes(this.parkingKind) &&
                (v.PARKING_NM?.includes(this.parkingName) || v.CELL_ADDR_JIBUN?.includes(this.parkingName)),
            );
          }
        } else if (this.searchOption === '1') {
          //주차장명
          this.parkingList = this.parkingList.filter(
            v => v.PARKING_DIV_NM?.includes(this.parkingKind) && v.PARKING_NM?.includes(this.parkingName),
          );
        } else if (this.searchOption === '2') {
          //  주소
          this.parkingList = this.parkingList.filter(
            v => v.PARKING_DIV_NM?.includes(this.parkingKind) && v.CELL_ADDR_JIBUN?.includes(this.parkingName),
          );
        }
      } else if (this.parkingKind === '0') {
        //전체
        if (this.searchOption === '0') {
          //전체
          if (this.parkingName === undefined) {
            this.parkingList = data.parkingList;
          } else if (this.parkingName !== undefined) {
            this.parkingList = this.parkingList.filter(
              v => v.PARKING_NM?.includes(this.parkingName) || v.CELL_ADDR_JIBUN?.includes(this.parkingName),
            );
          }
        } else if (this.searchOption === '1') {
          //주차장명
          this.parkingList = this.parkingList.filter(v => v.PARKING_NM?.includes(this.parkingName));
        } else if (this.searchOption === '2') {
          //  주소
          this.parkingList = this.parkingList.filter(v => v.CELL_ADDR_JIBUN?.includes(this.parkingName));
        }
      }
    },

    findRoads(parking) {
      window.open('https://map.kakao.com/link/to/' + parking.PARKING_NM + ',' + parking.LAT + ',' + parking.LNG);
    },
  },
};
</script>

<style lang="scss">
#mapWrapper {
  width: 100%;
  height: 370px;
  z-index: 5;
}

#mapWrapper #map {
  height: 370px;
}

@media screen and (max-width: 768px) {
  #mapWrapper {
    height: 120px;
  }
}
</style>
